import { PropertiesSection, Property } from './PropertiesSection';
import { T } from '../../../translation/src';
import { ConvertType, useFormatNumber } from '../../../hooks/useFormatNumber';
import { memo } from 'react';
import { PropertyPanel } from '../../Properties/components/PropertyPanel';
import { AnnotationType } from '../../Properties/types';
import { getBoxScaleProperty } from '@pointorama/potree-shared';
import { usePropertyValue } from '../../Properties/reactive/usePropertyValue';

interface BoxPropertiesProps {
  projectId: string;
  identifier: string;
}
const BoxProperties_: React.FC2<BoxPropertiesProps> = ({ projectId, identifier }) => {
  const { formatNumber } = useFormatNumber();

  const scale = usePropertyValue(getBoxScaleProperty(identifier));

  return (
    <div className="flex flex-col space-y-4 divide-y divide-gray-800">
      <PropertiesSection title={<T _str="information" swc />}>
        <Property title={<T _str="type" swc />}>
          <T _str="box" swc />
        </Property>
      </PropertiesSection>
      <PropertiesSection title={<T _str="measurements" swc />}>
        <Property title={<T _str="length" swc />}>{formatNumber(scale.x, { convertType: ConvertType.DISTANCE, addUnit: true })}</Property>
        <Property title={<T _str="width" swc />}>{formatNumber(scale.y, { convertType: ConvertType.DISTANCE, addUnit: true })}</Property>
        <Property title={<T _str="height" swc />}>{formatNumber(scale.z, { convertType: ConvertType.DISTANCE, addUnit: true })}</Property>
      </PropertiesSection>
      <PropertyPanel projectId={projectId} annotationTypes={[AnnotationType.BOX]} objectIdentifiers={[identifier]} />
    </div>
  );
};
export const BoxProperties = memo(BoxProperties_);
